<!--
 * @Author: yeqing
 * @Date: 2021-11-24 11:12:18
 * @LastEditTime: 2021-11-30 15:53:19
 * @LastEditors: Please set LastEditors
 * @Description: 创新能力组件
 * @FilePath: \fe-frame-page\src\views\enterpriseSpecial\littleGiant\components\innovationModel.vue
-->
<template>
    <div class="innovationModel">
        <a-form>
            <a-form-item label="1、企业所在的产业或细分技术领域" class="block">
                <div class="select_box">
                    <div class="item">
                        <div
                            class="title"
                            :class="isSelect == 1 ? 'active' : ''"
                            @click="onSelect(1, '')"
                        >
                            <span>“工业四基”重点领域</span>
                            <svg-icon :icon-class="isOpen == 1 ? 'zhankai' : 'shouqi'" class="icon"></svg-icon>
                        </div>
                        <a-radio-group
                            name="radioGroup"
                            v-model="innovation.q521"
                            class="detail"
                            v-if="isOpen == 1"
                        >
                            <a-radio value="核心基础零部件和元器件">核心基础零部件和元器件</a-radio>
                            <a-radio value="先进基础工艺1">先进基础工艺</a-radio>
                            <a-radio value="关键基础材料1">关键基础材料</a-radio>
                            <a-radio value="产业技术基础">产业技术基础</a-radio>
                        </a-radio-group>
                    </div>
                    <div class="item">
                        <div
                            class="title"
                            :class="isSelect == 2 ? 'active' : ''"
                            @click="onSelect(2, '')"
                        >
                            <span>细分产品市场</span>
                            <svg-icon :icon-class="isOpen == 2 ? 'zhankai' : 'shouqi'" class="icon"></svg-icon>
                        </div>
                        <a-radio-group
                            name="radioGroup"
                            v-model="innovation.q521"
                            class="detail"
                            v-if="isOpen == 2"
                        >
                            <a-radio value="制造业核心基础零部件">制造业核心基础零部件</a-radio>
                            <a-radio value="先进基础工艺2">先进基础工艺</a-radio>
                            <a-radio value="关键基础材料2">关键基础材料</a-radio>
                        </a-radio-group>
                    </div>
                    <div class="item">
                        <div
                            class="title"
                            :class="isSelect == 3 ? 'active' : ''"
                            @click="onSelect(3, '关键基础技术和产品的产业化攻关')"
                        >
                            <span>关键基础技术和产品的产业化攻关</span>
                        </div>
                    </div>
                    <div class="item">
                        <div
                            class="title"
                            :class="isSelect == 4 ? 'active' : ''"
                            @click="onSelect(4, '新一代信息技术与实体经济深度融合的创新产品')"
                        >
                            <span>新一代信息技术与实体经济深度融合的创新产品</span>
                        </div>
                    </div>
                    <div class="item">
                        <div
                            class="title"
                            :class="isSelect == 5 ? 'active' : ''"
                            @click="onSelect(5, '')"
                        >
                            <span>制造强国战略十大重点产业领域</span>
                            <svg-icon :icon-class="isOpen == 5 ? 'zhankai' : 'shouqi'" class="icon"></svg-icon>
                        </div>
                        <a-radio-group
                            name="radioGroup"
                            v-model="innovation.q521"
                            class="detail"
                            v-if="isOpen == 5"
                        >
                            <a-radio value="新一代信息技术产业">新一代信息技术产业</a-radio>
                            <a-radio value="高档数控机床和机器人">高档数控机床和机器人</a-radio>
                            <a-radio value="航空航天装备">航空航天装备</a-radio>
                            <a-radio value="海洋工程装备及高技术船舶">海洋工程装备及高技术船舶</a-radio>
                            <a-radio value="先进轨道交通装备">先进轨道交通装备</a-radio>
                            <a-radio value="节能与新能源汽车">节能与新能源汽车</a-radio>
                            <a-radio value="电力装备">电力装备</a-radio>
                            <a-radio value="农机装备">农机装备</a-radio>
                            <a-radio value="新材料">新材料</a-radio>
                            <a-radio value="生物医药及高性能医疗器械">生物医药及高性能医疗器械</a-radio>
                        </a-radio-group>
                    </div>
                    <div class="item">
                        <div
                            class="title"
                            :class="isSelect == 6 ? 'active' : ''"
                            @click="onSelect(6, '其他')"
                        >
                            <span>其他</span>
                        </div>
                    </div>
                </div>
            </a-form-item>
            <a-form-item label="2、是否自建或与高等院校、科研机构联合建立研发机构，设立技术研究院、企业技术中心、企业工程中心、院士专家工作站、博士后工作站等">
                <a-radio-group name="radioGroup" v-model="innovation.q522">
                    <a-radio value="是">是</a-radio>
                    <a-radio value="否">否</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item label="3、企业在研发设计、生产制造、供应链管理等环节，是否至少有1项核心业务采用信息系统">
                <a-radio-group name="radioGroup" v-model="innovation.q523">
                    <a-radio value="是">是</a-radio>
                    <a-radio value="否">否</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item label="4、企业是否拥有自主品牌">
                <a-radio-group name="radioGroup" v-model="innovation.q524">
                    <a-radio value="是">是</a-radio>
                    <a-radio value="否">否</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item label="5、企业是否取得相关管理体系认证，且产品生产执行国际、国内、行业标准或产品通过发达国家和地区产品认证">
                <a-radio-group name="radioGroup" v-model="innovation.q525">
                    <a-radio value="是">是</a-radio>
                    <a-radio value="否">否</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item class="row-box">
                <div class="lable">6、企业拥有有效发明专利：（含集成电路布图设计专有权）</div>
                <a-input
                    style="width: 170px; margin: 0 10px"
                    :value="innovation.q526"
                    @change="formatNumber($event, 'q526')"
                />
                <span class="unit">项</span>
            </a-form-item>
            <a-form-item class="row-box">
                <div class="lable">7、实用新型专利、外观设计专利、软件著作权：（含集成电路布图设计专有权）</div>
                <a-input
                    style="width: 170px; margin: 0 10px"
                    :value="innovation.q527"
                    @change="formatNumber($event, 'q527')"
                />
                <span class="unit">项</span>
            </a-form-item>
            <div style="text-align: center; margin-top: 40px;">
                <a-button class="primary-btn pre-btn" @click="handlePre">上一步</a-button>
                <a-button class="primary-btn" @click="handleNext">下一步</a-button>
            </div>
        </a-form>
    </div>
</template>

<script>
export default {
    name: "innovationModel",
    data() {
        return {
            innovation: {
                q521: "",
                q522: "",
                q523: "",
                q524: "",
                q525: "",
                q526: "",
                q527: "",
            },
            isSelect: 0, // 第一题
            isOpen: ''
        };
    },
    created() { },
    methods: {
        formatNumber(e, tag) {
            const { value } = e.target;
            const reg = /^-?[0-9]\d*$/;
            if (!isNaN(value) && reg.test(value)) {
                this.innovation[tag] = Number(value);
            }
        },

        onSelect(index, value) {
            this.isOpen == index ? this.isOpen = '' : this.isOpen = index
            this.isSelect = index
            this.innovation.q521 = value
        },
        // 下一步
        handleNext(e) {
            e.preventDefault();
            this.$emit("changeTabKey", {
                name: "innovation",
                key: 3,
                data: this.innovation,
            });
        },
        // 上一步
        handlePre(e) {
            e.preventDefault();
            this.$emit("changeTabKey", {
                name: "innovation",
                key: 1,
                data: this.innovation,
            });
        },
    },
};
</script>
<style lang="less" scoped>
.innovationModel {
    margin-top: 30px;

    ::v-deep .ant-form-item {
        margin-bottom: 6px;
    }
    ::v-deep .ant-form-item-label > label {
        color: #333333;
        font-size: 14px;
        // font-family: PingFangSC-Regular, PingFang SC;
    }
    ::v-deep .ant-radio-wrapper {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
    }
    .block {
        ::v-deep .ant-form-item-control-wrapper {
            display: block !important;
        }
    }
    .select_box {
        margin-top: -10px;
        margin-bottom: 12px;
        .item {
            margin-top: 20px;
            .title {
                width: 360px;
                height: 34px;
                background: #ffffff;
                border-radius: 3px;
                border: 1px solid #f0f0f0;
                line-height: 34px;
                padding-left: 20px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-right: 10px;
                &:hover {
                    border: 1px solid #0072f7;
                    color: #0072f7;
                }
                .icon {
                    width: 10px;
                }
            }
            .active {
                border: 1px solid #0072f7;
                color: #0072f7;
            }
            .detail {
                ::v-deep.ant-radio-wrapper {
                    margin-top: 20px;
                }
            }
        }
    }
    .row-box {
        .lable {
            margin: 0;
            padding: 0 0 8px;
            line-height: 1.5;
            white-space: initial;
            text-align: left;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #333333;
            margin-right: 6px;
            font-size: 14px;
            display: inline-block;
            > span {
                color: #999999;
            }
        }
        .unit {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
        }
    }
    .primary-btn {
        width: 133px;
        height: 40px;
        border-radius: unset;
        background: #0072f7;
        border-radius: 2px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 16px;
        border: none;
        &:hover {
            color: #fff;
            background-color: #40a9ff;
            border-color: #40a9ff;
        }
    }
    .pre-btn {
        background: #fff;
        color: #999;
        margin-right: 20px;
        border: 1px solid #eeeeee;
        &:hover {
            background-color: #fff;
            color: #40a9ff;
            border-color: #40a9ff;
        }
    }
}
</style>